const CONSTANTS = {
    ADD_ACTION: 'add_action',
    REMOVE_ACTION: 'remove_action',
    ADD_SUCCESS_DATA: 'addSuccessData',
    CREATE_PAYMENT_DATA: 'createPaymentData'
};

export default CONSTANTS;